// import React from 'react';
// import { Redirect } from 'react-router-dom';
import { createClient } from 'contentful';
import _ from 'lodash';
import { getEnvironment } from './utils/request';

export const contentfulFormConfig = {
  include: 8,
  limit: 1000,
  content_type: 'formsContainer'
};

export const contentfulTranslationsConfig = {
  include: 8,
  limit: 1000,
  content_type: 'translations'
};

export const contentfulPagesConfig = {
  include: 8,
  limit: 1000,
  content_type: 'page'
};

class ContentfulService {
  static instance;

  client = null;

  constructor(credentials) {
    if (ContentfulService.instance) {
      return ContentfulService.instance;
    }
    this.client = createClient(credentials);
    ContentfulService.instance = this;
  }
}

// const checkUser = async () => {
//     try {
//       return await request.get('/users/profile');
//     } catch (err) {
//       return <Redirect to="/login" />;
//     }
// };

export const getContentfulData = async config => {
  try {
    const { contentfulConfig } = getEnvironment();
    const contentfulService = new ContentfulService(contentfulConfig);
    return contentfulService.client.getEntries(config);
  } catch (err) {
    throw new Error(err);
  }
};

export const getRegistrationContentfulData = async config => {
  try {
    const { contentfulConfig } = getEnvironment();
    const contentfulService = new ContentfulService(contentfulConfig);
    return contentfulService.client.getEntries(config);
  } catch (err) {
    throw new Error(err);
  }
};

export const getData = data =>
  data && data.items && data.items.length && data.items[0].fields;

export const getMultipleData = data => (data && data.items) || [];

export const getWLNFormSteps = (config, setData) => {
  getContentfulData(config).then(res => {
    const { formCategories } = getData(res);

    const categoryWLN = formCategories.find(
      category =>
        _.get(category, 'fields.name', '') === 'wireline and secure business'
    );

    const wlnOrderSummaryFrom = _.get(categoryWLN, 'fields.forms', []).find(
      form => _.get(form, 'fields.name', '') === 'Order Details'
    );
    setData(_.get(wlnOrderSummaryFrom,"fields.steps",[]))
    // getProgressBarStepsWLN(orderData.productSelection,_.get(wlnOrderSummaryFrom,"fields.steps",[]))
  });
};

export const getWLSFormSteps = (config, setData) => {
  getContentfulData(config).then(res => {
    const { formCategories } = getData(res);
    console.log(formCategories,"form categories")
    const categoryWLN = formCategories.find(
      category =>
        _.get(category, 'fields.name', '') === 'wireline and secure business'
    );

    const wlnOrderSummaryFrom = _.get(categoryWLN, 'fields.forms', []).find(
      form => _.get(form, 'fields.name', '') === 'Order Details'
    );
    setData(_.get(wlnOrderSummaryFrom,"fields.steps",[]))
    // getProgressBarStepsWLN(orderData.productSelection,_.get(wlnOrderSummaryFrom,"fields.steps",[]))
  });
};